import * as React from 'react';
import OrdersLayout from "../components/OrdersLayout"

const CanceledOrders: React.SFC = () => {
    return ( 
        <OrdersLayout/>
     );
}
 
export default CanceledOrders;